/**
 * Скопіювати текст у буфер обміну.
 *
 * Основний шлях — Clipboard API; він працює лише в безпечному контексті
 * (https або localhost). Для решти — старий `execCommand('copy')` через
 * тимчасове поле: застарілий, але досі єдиний, що працює без https.
 *
 * @returns чи вдалося скопіювати — щоб не показати «Скопійовано», коли ні
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text)

            return true
        }
    } catch {
        // Браузер відмовив (немає дозволу) — пробуємо запасний шлях
    }

    const area = document.createElement('textarea')
    area.value = text
    area.setAttribute('readonly', '')
    area.style.position = 'fixed'
    area.style.opacity = '0'
    document.body.appendChild(area)
    area.select()

    try {
        return document.execCommand('copy')
    } catch {
        return false
    } finally {
        document.body.removeChild(area)
    }
}
